import { render, staticRenderFns } from "./UnidadeMedida.vue?vue&type=template&id=03c010b4&scoped=true&"
import script from "./UnidadeMedida.vue?vue&type=script&lang=js&"
export * from "./UnidadeMedida.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeMedida.vue?vue&type=style&index=0&id=03c010b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c010b4",
  null
  
)

export default component.exports